import { supabase } from '../config/supabase';

export interface SubmitSOSEventParams {
  tripId: string;
  reporterRole: 'driver' | 'client';
  eventType: string;
  description?: string | null;
  contactPhone?: string | null;
  photoUrl?: string | null;
  location?: string | null;
}

export async function submitSOSEvent(
  params: SubmitSOSEventParams
): Promise<{ error: Error | null }> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    return { error: new Error('You must be logged in to report an SOS') };
  }

  const { error } = await supabase.from('sos_events').insert({
    trip_id: params.tripId,
    reporter_id: user.id,
    reporter_role: params.reporterRole,
    event_type: params.eventType,
    description: params.description ?? null,
    contact_phone: params.contactPhone ?? null,
    photo_url: params.photoUrl ?? null,
    location: params.location ?? null,
    status: 'new',
  });

  return { error: error ? new Error(error.message) : null };
}
